<template>
    <main>
        <section class="page404">
            <svg xmlns="http://www.w3.org/2000/svg" width="179.548" height="24.693" viewBox="0 0 179.548 24.693"><path d="M102,5.5v6.752H94.343V5.5h-4.22V23.227h4.22V16.1H102v7.126h4.218V5.5H102Z" transform="translate(-33.038 -2.018)" fill="#fff"/><path d="M131.96,5.5l-4.414,7.018L123.135,5.5h-4.979l7.284,11.585v6.139h4.216V17.089L136.941,5.5H131.96Z" transform="translate(-43.316 -2.018)" fill="#fff"/><path d="M162.364,5.5V18.5a.876.876,0,0,1-.9.892H154.7V5.5h-4.218V23.227h12.466a3.363,3.363,0,0,0,3.625-3.621V5.5h-4.212Z" transform="translate(-55.168 -2.018)" fill="#fff"/><path d="M194.534,5.5h-12.47V23.227h4.218V9.342h6.767a.876.876,0,0,1,.894.887v13h4.213V9.128a3.6,3.6,0,0,0-.972-2.646A3.6,3.6,0,0,0,194.534,5.5Z" transform="translate(-66.744 -2.018)" fill="#fff"/><path d="M226.113,5.5H213.644V23.227h12.469a3.368,3.368,0,0,0,3.621-3.621V9.128a3.594,3.594,0,0,0-.977-2.649A3.6,3.6,0,0,0,226.113,5.5Zm-.593,4.754v8.213a.893.893,0,0,1-.9.917h-6.762V9.342h6.735A.884.884,0,0,1,225.519,10.258Z" transform="translate(-78.32 -2.018)" fill="#fff"/><path d="M248.552,5.5a3.573,3.573,0,0,0-2.645.978,3.577,3.577,0,0,0-.975,2.646v14.1h4.208V17.745H256.8v5.483h4.213V5.5ZM256.8,9.342v4.565h-7.663V10.243a.9.9,0,0,1,.9-.9Z" transform="translate(-89.791 -2.018)" fill="#fff"/><rect width="4.217" height="17.723" transform="translate(175.33 3.486)" fill="#fff"/><g transform="translate(0 0)"><g transform="translate(0 0)"><path d="M24.112,24.693c13.317,0,24.113-5.527,24.113-12.348S37.429,0,24.112,0,0,5.528,0,12.346,10.8,24.693,24.112,24.693Zm4.538-6.059c-.4.934-1.094,2.926-2.684,3.717a4.025,4.025,0,0,1-1.609.37c-.12,0-.2,0-.241,0a41.941,41.941,0,0,1-12.059-1.674c-.03-.008-.109-.04-.134-.049-.319-.106-.483-.256-.483-.436a.537.537,0,0,1,.2-.392c.048-.05.122-.111.219-.2a28.224,28.224,0,0,1,7.755-4.153,38.16,38.16,0,0,1,5.673-1.808C26.508,13.757,31.048,13.063,28.65,18.635ZM40.833,6.19a.491.491,0,0,1,.407-.288.835.835,0,0,1,.5.165c2.833,1.743,4.51,3.918,4.51,6.275,0,4.26-5.475,7.918-13.3,9.519-.5.1-.836.1-.951-.031a.3.3,0,0,1,0-.383,2.012,2.012,0,0,1,.208-.29c4.264-5.025,7.51-12.436,8.433-14.576C40.71,6.432,40.779,6.286,40.833,6.19ZM19.645,6.031c.4-.93,1.1-2.922,2.684-3.714a4,4,0,0,1,1.609-.369c.119,0,.2,0,.239,0A41.893,41.893,0,0,1,36.242,3.624c.025.007.106.039.131.048.32.107.485.253.485.437a.549.549,0,0,1-.2.391c-.049.049-.122.112-.219.193a28.161,28.161,0,0,1-7.753,4.152,38.064,38.064,0,0,1-5.673,1.81C21.786,10.914,17.248,11.6,19.645,6.031Zm-4.373-3.2c.5-.1.835-.1.955.032a.32.32,0,0,1,0,.379,2.343,2.343,0,0,1-.211.289c-4.263,5.026-7.51,12.439-8.433,14.58-.069.147-.139.293-.2.389a.484.484,0,0,1-.4.289.866.866,0,0,1-.5-.164C3.65,16.877,1.967,14.7,1.967,12.344,1.967,8.085,7.443,4.425,15.272,2.827Z" transform="translate(0 0)" fill="#fff"/></g></g></svg>
            <h2><span>i</span>404</h2>
            <p>Este modelo não foi encontrado. Volte à estrada principal.</p>
            <GovButton :displayAtag="false" toRoute="/" btnClass="btn-white" btnText="Seguir viagem" svgItem="arrow" />
        </section>
    </main>
</template>
<script>
    import GovButton from '../components/Buttons/GovButton.vue'

    export default {
        name: 'page404',
        components:{ GovButton }
    }
</script>
<style lang="scss">
    .page404{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        height: calc(100vh - 180.5px);
        background-color: $primaryCol;

        h2{
            font-family: $boldFont;
            font-size: 70px;
            color: $whiteCol;
            text-align: center;
            margin: 1rem auto;

            span{
                font-family: $boldFont;
                color: $orangeCol;
                padding-right: .25rem;
            }
        }

        p{
            margin: 0 2rem 3rem;
            @include mixin_text_content(default, $whiteCol, center, $mediumFont, 404, 1.5rem)
        }

    }

    @include respond-to(large){
        .page404{

            h2{ font-size: 100px; }
        }
    }
</style>
